// extracted by mini-css-extract-plugin
export default {"header":"header_header__pXEd5","logo":"header_logo__61NfZ"};